import MeetingInviteModal from './MeetingInviteModal'

export default MeetingInviteModal
